import { render, staticRenderFns } from "./RegionMenuHeader.vue?vue&type=template&id=03c9c450&scoped=true"
import script from "./RegionMenuHeader.vue?vue&type=script&lang=js"
export * from "./RegionMenuHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c9c450",
  null
  
)

export default component.exports